<template>
  <healthcheck-form
    :distribution-id="distributionId"
    @submit="addHealthcheck"
    @close="$emit('closed')"
  />
</template>
<script>
import HealthcheckForm from '../healthcheck/Form.vue'

export default {
  name: 'CreateDistributionHealthcheck',
  components: {
    HealthcheckForm,
  },
  props: {
    distributionId: {
      type: String,
      required: true,
    },
  },
  methods: {
    addHealthcheck(healthcheck) {
      const query = {
        distributionId: this.distributionId,
        healthcheck: {
          name: healthcheck.name,
          requestMethod: healthcheck.requestMethod,
          requestPath: healthcheck.requestPath,
          host: healthcheck.host,
          expectedResponse: healthcheck.expectedResponse,
          threshold: healthcheck.threshold,
          window: healthcheck.window,
          interval: healthcheck.interval,
          timeout: healthcheck.timeout,
        },
      }
      this.$store.dispatch('cdn/addHealthcheck', query).then(() => {
        this.successToast('Healthcheck was added')
        this.$emit('added')
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating healthcheck.') })
    },
  },
}
</script>
